<template>
  <tr
  v-if="vmode===0">

    <td class="sticky">

      <div
      class="rlink-hover color1--text"
      style="text-decoration: none;display:inline-flex;align-items: center;"
      @click.stop="$root.$timelineNav.open(item.archive_id)">
        <v-icon small color="color1" style="transition: none;">mdi-qrcode-scan</v-icon>
        <span class="ml-1">{{ item.archive_id }}</span>
      </div>

    </td>

    <td>
      <span v-if="item.internal_code">
        {{ item.internal_code }}
      </span>
      <span v-else class="grey--text caption">
        (not defined)
      </span>
    </td>

    <td>
      <div class="c-flex align-center">
        <v-avatar
        :color="item.id_name ? (lastVisited ? 'color1' : 'red lighten-2') : 'green accent-4'"
        class="headline font-weight-light white--text">
          {{ (item.id_name || '?').charAt(0) }}
        </v-avatar>
        <span class="ml-2 text-ellipsed" v-html="highlightedName">
          
        </span>
      </div>
    </td>

    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue="item.quantity"
      :metric.sync="currentMetric"
      alwaysScale
      labelMode
      :key="item.id"
      ></c-ms-ii>
    </td>

    <td>
      <cost-per-unit 
      :currencyLabel="currencyLabel"
      :realCost.sync="item.cost_per_unit"
      :inventoryItemID="item.inventory_item_id"
      :metric.sync="currentMetric" 
      :focussed.sync="costPerUnitHasFocus"></cost-per-unit>
    </td>

    <td>
      <c-price :quantity.sync="totalCost" :focussed.sync="totalCostHasFocus" :currency="currency">
      </c-price>
    </td>

    <td>
      <c-select-supplier :selectedID.sync="item.supplier_id"></c-select-supplier>
    </td>

    <td>
      <c-input :value.sync="item.batch_number"></c-input>
    </td>

    <td>
      <c-date :date.sync="item.expiry_date"></c-date>
    </td>
    
    <td>
      <c-input :value.sync="item.vat"></c-input>
    </td>

  </tr>

  <!-- MOBILE -->
  <div 
  v-else-if="vmode === 1"
  v-ripple
  :class="['c-flex-r mrow', {'selected-row': selected[item.tempID]}]" style="position: relative;">

    <v-icon 
    @click.stop="$emit('checkRow', item)"
    :color="selected[item.tempID] ? 'text' : ''"> 
      {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
    </v-icon>

    <v-list-tile-avatar
    :color="item.id_name ? (lastVisited ? 'color1' : 'red lighten-2') : 'green accent-4'"
    class="headline font-weight-light white--text">
      {{ (item.id_name || '?').charAt(0) }}
    </v-list-tile-avatar>

    <!--
    <img class="c-align-self-start" src="@/assets/img/illustrations/cardboard-box.png" alt="cardboard box" width="42px">
    -->
    
    <div class="c-flex-c1">
      <v-layout>
        <v-flex xs6 class="c-flex-00a">
          <div 
          v-if="!item.id_name"
          class="caption">
            *Empty row
          </div>
          <template
          v-else>
            <div class="font-weight-bold">
              {{ item.id_name }}
            </div>
            <div class="text--text text--darken-1">
              <c-ms-ii
              :metric_definition="item.definition" 
              :realValue="item.quantity"
              alwaysScale
              labelMode
              :key="item.id"
              ></c-ms-ii>

            </div>
          </template>
        </v-flex>
        <v-flex 
        class="c-flex-00a"
        xs6>
          <div v-if="extraColumn === 'Supplier'">
            {{ supplier.name }}
          </div>
          <div v-if="extraColumn === 'Batch Number'">
            {{ item.batch_number }}
          </div>
          <div v-if="extraColumn === 'Expiry Date'">
            {{ expiryDate }}
          </div>
        </v-flex>
      </v-layout>
      
    </div>
  </div>

  <!-- DIALOG -->
  <div
  v-else-if="vmode === 2">
    <div class="text-xs-center">
      <img style="align-self: center;" src="@/assets/img/illustrations/cardboard-box.png" alt="cardboard box" width="80px">
    </div>

    <div class="inputcontainer">
      <div class="caption">
        Item
      </div>
      <c-select-inv-def 
      placeholder="Select item" 
      fixed="true" border="false" :selectedID.sync="item.inventory_item_id">
      </c-select-inv-def>
    </div>

    <div class="inputcontainer">
      <div class="caption">
        Quantity
      </div>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity"
      :metric.sync="currentMetric"
      :key="item.id"
      ></c-ms-ii>
    </div>

    <div class="inputcontainer">
      <div class="caption">
        Supplier
      </div>
      <c-select-supplier selectedID.sync="item.supplier_id" :update:selectedID="setSupplierID">
      </c-select-supplier>
    </div>
    
    <div class="inputcontainer">
      <div class="caption">
        Batch number
      </div>
      <c-input :value.sync="item.batch_number">
      </c-input>
    </div>
    
    <div class="inputcontainer">
      <div class="caption">
        Expiry date
      </div>
      <c-date :date.sync="item.expiry_date">
      </c-date>
    </div>
    
    <div class="inputcontainer">
      <div class="caption">
        Cost per unit
      </div>
      <cost-per-unit 
      :realValue.sync="item.cost_per_unit"
      :inventoryItemID="item.inventory_item_id"
      :metric.sync="currentMetric" 
      :focussed.sync="costPerUnitHasFocus">
      </cost-per-unit>
    </div>
    
    <div class="inputcontainer">
      <div class="caption">
        Price
      </div>
      <c-price :quantity.sync="totalCost" :focussed.sync="totalCostHasFocus">
      </c-price>
    </div>
    
    <div class="inputcontainer">
      <div class="caption">
        VAT
      </div>
      <c-input :value.sync="item.vat"></c-input>
    </div>
  </div>
</template>

<script>
import CostPerUnit from '@/components/select/CostPerUnit'
import {BigNumber} from 'bignumber.js'

export default {
  props: {
    vmode: null,
    searchText: null,
    item: null,
    extraColumn: null,
    selected: null,
    lastVisited: null,
    currency: null
  },
  components: { CostPerUnit },
  data () {
    return {
      costPerUnitHasFocus: false,
      totalCostHasFocus: false,
      totalCost: 0,
      currentMetric: 0
    }
  },
  computed: {
    currencyLabel () {
      return (this.$store.state.db.currencies.items[this.currency] || {}).symbol
    },
    supplier () {
      return this.$store.state.db.suppliers.suppliers[this.item.supplier_id] || {}
    },
    expiryDate () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('ddd DD/MM/YYYY')
      }
      return ''
    },
    automaticTotalCost () {
      return new BigNumber(this.quantityInUnits).times(this.item.cost_per_unit).toNumber()
      // return this.quantityInUnits * this.item.cost_per_unit
    },
    automaticCostPerUnit () {
      return new BigNumber(this.totalCost).dividedBy(this.quantityInUnits).toNumber()
    },
    quantityInUnits () {
      // in the new system lets save in the native metric?
      if (!this.item.definition) {
        return this.item.quantity
      }
      switch (this.item.definition.metric) {
        case 0:
          return this.item.quantity
        case 1:
          // ml - litres
          return new BigNumber(this.item.quantity).dividedBy(1000)
        case 2:
          // mg - kg
          return new BigNumber(this.item.quantity).dividedBy(1000 * 1000)
        case 3:
          // mm - m
          return new BigNumber(this.item.quantity).dividedBy(1000)
      }
    },
    highlightedName () {
      var replacedStr = (this.searchText || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.id_name.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular">$&</span>')
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    }
  },
  methods: {
    setSupplierId(payload) {
      this.$set(this.item, "supplier_id", payload);
    }
  },
  watch: {
    automaticTotalCost (nv) {
      if (!this.totalCostHasFocus) {
        this.totalCost = nv
      }
    },
    automaticCostPerUnit (nv) {
      if (!this.costPerUnitHasFocus) {
        this.item.cost_per_unit = nv
        if (isNaN(this.item.cost_per_unit)) {
          this.item.cost_per_unit = 0
        }
      }
    }
  },
  created () {
    this.totalCost = this.automaticTotalCost
  }
}
</script>

<style scoped lang="scss">
.mrow {
  padding: 8px;
  cursor: pointer;
  border-bottom: thin solid rgba(0,0,0,0.15);
}
.mrow:hover {
  box-shadow: 0px 1px 3px rgba(0,0,0,0.35);
}
.selected-row {
  border-bottom: thin solid rgba(0,0,0,0.15);
}
.selected-row::before {
  background: var(--v-color1-base);
  height: 100%;
  width: 100%;
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  opacity: 0.1;
}
.inputcontainer {
  background: #f5f5f5;
  border-radius: 2px;
  padding: 6px 6px 0 6px;
  margin-bottom: 8px;

  & .caption {
    color: var(--v-text-darken1);
  }

  & .crx-input {
    margin-top: 0px;

    &:before {
      content: none;
    }
  }
}
</style>
